import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getLogger } from '@nerdwallet/logging';

const logger = getLogger('redirect-utils');

const REDIRECT_TIMEOUT = 1500;
export { REDIRECT_TIMEOUT as default };

export const extractHeaderInformation = (req) => {
  const { headers } = req;

  const originatingIP = headers['x-originating-ip'];
  const forwardedIP = headers['x-forwarded-for'];
  let ip;
  if (originatingIP) {
    ip = originatingIP;
  } else if (forwardedIP) {
    // The Edge can set multiple IPs such as "4.7.8.106, 172.20.101.78"
    // We should split and take the LEFT most IP as the originating
    const ipParts = forwardedIP.split(',');
    // eslint-disable-next-line prefer-destructuring -- directive added automatically by Shepherd migration
    ip = ipParts[0];
  } else {
    ip = req.ip; // Fallback to whatever ExpressJS sets
  }

  return {
    ip,
    referrer:
      _.get(req, 'query.source_url') ||
      _.get(req, 'query.url') ||
      headers.referer,
    userAgent: headers['user-agent'],
    pageViewId: headers['x-pageview-id'],
    cookieId: headers['x-cookie-id'],
    browserSessionId: headers['x-browser-session-id'],
  };
};

export const redactEventData = (eventData = {}) => {
  const e = eventData;
  // PFLEND-634 - let TPID query param be logged along with destination_url
  let customShortId = null;
  try {
    customShortId = new URL(eventData.destination_url).searchParams.get('TPID');
  } catch (err) {
    logger.warn('error extracting custom short ID from url:', err);
  }

  // PP-3424 - avoid exposing any user data in logs
  const destinationUrlParts = eventData.destination_url
    ? eventData.destination_url.split('?')
    : [];
  if (destinationUrlParts.length > 1) {
    if (customShortId)
      e.destination_url = `${destinationUrlParts[0]}?TPID=${customShortId}`;
    // eslint-disable-next-line prefer-destructuring -- directive added automatically by Shepherd migration
    else e.destination_url = destinationUrlParts[0];
  }

  return e;
};

export const createClickHeader = (req, product) => {
  // Strip dashes to maintain consistency
  const uid =
    _.get(req, 'query.shopping_finish_id') ||
    _.get(req, 'query.finish_id') ||
    product.uniqueClickId ||
    uuidv4().replace(/-/g, '');
  const out = {
    productId: product.productId,
    productSlug: product.productSlug,
    category: product.category,
    sponsored: product.sponsored,
    monetizing: product.monetizing,
    affiliateId: product.affiliateId,
    uniqueClickId: uid,
  };

  const queryParams = [
    'clickHeader_impressionId',
    'clickHeader_productLocation',
    'clickHeader_productPosition',
    'clickHeader_sectionPosition',
    'clickHeader_sectionName',
    'clickHeader_pageNumber',
    'clickHeader_productInstance',
    'clickHeader_linkType',
    'clickHeader_offerVersionId',
    'clickHeader_category',
    'prequal_id',
  ];

  queryParams.forEach((field) => {
    let headerField = field;

    if (headerField.indexOf('clickHeader_') === 0) {
      headerField = headerField.replace('clickHeader_', '');
    }

    if (out[headerField] === undefined) {
      if (req.query[field] && req.query[field].length > 0) {
        out[headerField] = req.query[field];
      }
    }
  });

  return out;
};
